// All Constants Here

// Development
// export  const BASE_URL = "http://127.0.0.1:8000/api"

// Production
export const BASE_URL = "https://hms.undp.ht/api";


export const UNIT_OPERATIONS = {
    Operation: ["Administration", "Finance", "Human Resources", "ICT", "Procurement", "Security"],
    Program: ["Management", "MSU", "Communication", "Résilience", "Gouvernance", "Inclusion"],
};

export const MODE_OF_WORK = ["In Office", "Telework", "On Mission", "On Leave"];

export const TYPE_OF_CONTRACT = ["IC", "UNV", "NPSA", "FTA", "TA", "PA"]

export const DUTY_STATION = ["Reimbold", "Pinchinat", "Cayes", "Jérémie", "Fort-Liberté", " Port-de-Paix"]

export const SUPERVISER = [
    "Jean Adler Auguste",
    "Sekou Bangoura",
    "Mactar Fall",
    "Darline Monfort",
    "Mackenzy Hector",
    "Oumar Diallo",
    "djenanne feliz-desir",
    "Guims Germain",
    "Marc Joanis Cupidon",
    "Rony Couloute",
    "Marie Marcelle Raymond",
    "sadrack paulime",
    "Xavier Michon",
    "lionel castanier",
    "Abdoulaye Diane",
    "Evans Stenley Simon",
    "Robertho Romilus",
    "Adrienne Vilton Pierre",
    "Jean Ronald Alexandre",
    "Joseph Hervens Jeanty",
    "Amor Boubakri",
    "Antoine Pierre",
    "Patrice Laventure",
    "John Wonghi Ngum",
    "Dietmar Fink",
    "Eric Pliya",
    "Marie Kathleen Blain",
    "Olivier Kambala1",
    "Katiana Macius",
    "Juvigny Jacques",
    "Ruvens Ely Boyer",
    "Savin Felicite Kpoli-Ouatto",
    "Guytho Alphonse",
    "Christelle Josiane Bela Foe",
    "Philippe Lamarche",
    "Gabriel Emmanuel Oscar",
    "Sifra Clergilus",
    "Yvio Georges",
    "Sylvain Merlen",
    "Seth Lee Daniel Cador",
    "Pierre-Claude Dumeus",
    "Yves Vilton",
    "wanick charles1",
    "Diane Sheinberg",
    "Darlene B PHILIPPE",
    "rodeans duogene",
    "robert jean felix",
    "Kamil Kamaluddeen",
    "Frantz Gilot",
    "Barbara Eljun",
    "Myriame Elvariste St Vil",
    "huda khattab",
    "mamadou bamba1",
    "Michelle Muschett"
]
.sort()

export const GENDER = ["Male", "Female", "Other"]

export const STAFF_STATUS = ["International", "National", "UNV"]

export const CATEGORY_OPTIONS = [
    "Laptop",
    "Monitor",
    "Radio",
    "Phone",
    "Printer",
    "Combo keyboard wireless",
    "TV",
    "Desktop",
    "Modem",
    "Accessories"
];

export const STATUS_OF_EQUIPMENT_OPTIONS = [
    "In use",
    "In stock",
    "In repair",
    "In disposal"
];

export const DELIVERY_TYPE_OPTIONS = [
    "Assignment",
    "Loan"
];

export const DEVICE_CONDITION_OPTIONS = [
    "New",
    "Good",
    "Defective"
];

export const TRAINING_LIST = [
    "Anti-fraud e-learning: Fraud and Corruption Awareness and Prevention",
    "BSAFE",
    "Ethics and Integrity at UNDP",
    "Preventing Sexual Harassment and Other Prohibited Conduct",
    "Prevention of Sexual Exploitation and Abuse of the Local Population (PSEA)",
    "Disability and Inclusion",
    "Greening The Blue",
    "The Gender Journey",
    "Safe and Secure Approaches in Field Environments (SSAFE)",
    "UNDP Foundations",
    "UNDP Legal Framework",
    "United Nations Human Rights Responsibilities"
];

export const TRAINING_MODES = ["Online", "In the Field"];

export const TRAINING_STATUSES = ["Completed", "Ongoing", "Not Started"];

export const YEARS = Array.from({ length: 30 }, (_, i) => new Date().getFullYear() - i); // Last 30 years

export const BLOOD_TYPES = [
    'A+',
    'A-',
    'B+',
    'B-',
    'AB+',
    'AB-',
    'O+',
    'O-',
];

export const ID_TYPES = [
    { value: 'Passport', label: 'Passport' },
    { value: "Driver's License", label: "Driver's License" },
    { value: 'National ID', label: 'National ID' },
    { value: 'Diplomatic Card', label: 'Diplomatic Card' },
    { value: 'UNLP', label: 'UNLP' },
];
